import { PopularTabType } from '@/interfaces/titles';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import axios from 'axios';
import { useRoutingStore } from '@/stores/pinia/useRoutingStore';

interface Plan {
	provider: string;
	title: string;
	monthly?: string;
	yearly?: string;
	simultaneous_streams: number | string;
	video_quality: string;
	link: string;
	otherServices: string;
	content: string;
}

export function getSelectedTab(routeName: string): PopularTabType | undefined {
	const name = routeName.split('app.titles.popular.provider')[1];
	if (name === undefined) {
		return undefined;
	}
	switch (name) {
		case '-movie':
			return PopularTabType.MOVIE;
		case '-show':
			return PopularTabType.SHOW;
		default:
			return PopularTabType.ALL;
	}
}

export function trackTitleClick(moduleName: string, useLastRouteName: boolean = true) {
	const routingStore = useRoutingStore();
	const routeName = (useLastRouteName ? routingStore?.lastRoute?.name : routingStore?.activeRoute?.name) as string;

	const selectedTab = getSelectedTab(routeName);

	TrackingHelper.trackEvent('userinteraction', {
		action: 'title_clicked',
		label: moduleName,
		property: selectedTab,
	});
}

export async function loadProviderPlan(short_name: string) {
	try {
		const data = await axios.get<Plan[]>(`${ASSETS_DIR}/json_data/provider_plans/${short_name}.json`);
		return data.data;
	} catch (error) {}
	return [];
}
